export default __webpack_public_path__ + "static/media/FormScreen.ac7fddee.gif";